// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"7dc72fc4","453":"c5f0a7ff","796":"77918d4e"}[chunkId] + ".chunk.js";
};